module.exports = __webpack_public_path__ + "static/media/trophyDefault.5219d29c.png";